import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule, NgbPopoverModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { translationChunksConfig } from '@spartacus/assets';
import { CmsConfig, ConfigModule, I18nModule, provideConfig } from '@spartacus/core';
import { OutletPosition, provideOutlet } from '@spartacus/storefront';
// import { ChartsModule } from 'ng2-charts';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BaseChartDirective } from "ng2-charts";
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { FluDashboardBannerModule } from '../shared/modules/flu-dashboard-banner/flu-dashboard-banner.module';
import { NeedToGoBackModule } from '../shared/modules/need-to-go-back/need-to-go-back.module';
import { ProductSearchModule } from '../shared/modules/product-search/product-search.module';
import { LatestPaymentComponent } from './latest-payment/latest-payment.component';
import { OldPaymentComponent } from './old-payment/old-payment.component';
import { PaymentHistoryComponent } from './payment-history/payment-history.component';
import { TransactionalDataComponent } from './transactional-data/transactional-data.component';
@NgModule({
  declarations: [PaymentHistoryComponent, TransactionalDataComponent, LatestPaymentComponent, OldPaymentComponent],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    I18nModule,
    NeedToGoBackModule,
    FluDashboardBannerModule,
    NgSelectModule,
    BsDatepickerModule,
    ProductSearchModule,
    // ChartsModule,
    BaseChartDirective,
    NgbModule,
    NgbPopoverModule,
    NgbTooltipModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ListOfPaymentHistoryBannerComponent: {
          component: PaymentHistoryComponent,
        },
        TransactionalDataComponent: {
          component: TransactionalDataComponent,
        }
      },
    } as CmsConfig)
  ],
  providers: [
    provideOutlet({
      id: 'TransactionalDataSlot',
      position: OutletPosition.REPLACE,
      component: TransactionalDataComponent,
    }),
    provideOutlet({
      id: 'MarketingBanner',
      position: OutletPosition.REPLACE,
      component: PaymentHistoryComponent,
    }),
    provideConfig({
      i18n: {
        backend: {
          loadPath: 'assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: translationChunksConfig,
      },
    }),
  ]
})
export class PaymentHistoryModule { }
